module.exports = __webpack_public_path__ + "static/media/mod.84c1b230.svg";